import { AnimatePresence, motion } from 'framer-motion';
import { observer } from 'mobx-react-lite'
import React from 'react'
import { useStore } from '../../../../../../hooks/useStore'
import { MapPointOfInterestMenu } from '../point-of-interest';

const MapPOILayer = observer(({data}) => {
    const {uiStore: {mapOffsetPx: {x, y}, home__map__activeCity, home__map__showClouds}} = useStore();
    let orgData;
    switch(home__map__activeCity) {
        case "Atlanta":
            orgData = data.orgsAtlanta.edges;
            break;
        case "Chicago":
            orgData = data.orgsChicago.edges;
            break;
        case "LA":
            orgData = data.orgsLA.edges;
            break;
        case "Detroit":
            orgData = data.orgsDetroit.edges;
            break;
        case "Philadelphia":
            orgData = data.orgsPhiladelphia.edges;
            break;
        case "Buffalo":
            orgData = data.orgsBuffalo.edges;
            break;
        default:
            return null;
    }

    // const oldPois = tempPOIs[home__map__activeCity];
    const style = {
        transform: `translate3d(${-x}px, ${
          y}px, 0)`,
    }
    // const style = {};
    
    // console.log(orgData)
    // return null;


    return (
        <AnimatePresence exitBeforeEnter>
            {
                home__map__showClouds ? 
                null : 
                <motion.div 
                    // key={"poi-layer" + home__map__activeCity}
                    initial={{opacity: 0}}
                    animate={{opacity: 1, transition: {delay: 1.8 , duration: .6}}}
                    exit={{opacity: 0}}>
                        <div style={style}>
                            {orgData.map((org, idx) => {
                                if (!org.node.mapLocation) return null

                                return (
                                    <POI key={`poi-${home__map__activeCity}-${idx}`} data={org.node} index={idx}/>
                                )
                            })}
                        


                            <style jsx>{`
                                div {
                                    position: absolute;
                                    top: 0;
                                    left: 0;
                                    bottom: 0;
                                    right: 0;
                                }

                            `}</style>
                        </div>

                </motion.div> 
            }

        </AnimatePresence>

    )
});

const POI = observer(({data, index}) => {
    const {uiStore: {home__map__activePOI}} = useStore();
    const isInactive = home__map__activePOI !== null && home__map__activePOI !== index;
    const isActive = home__map__activePOI === index;

    return (
        <div className={`poi ${isInactive ? "inactive" : ""} ${isActive ? "active" : ""}`}>
            {/* <div className='label'>
                <h6></h6>
            </div> */}
            <MapPointOfInterestMenu data={data} index={index}/>

            <style jsx>{`
                .poi {
                    top: ${data.mapLocation.y}%;
                    left: ${data.mapLocation.x}%;
                }
            `}</style>

            <style jsx>{`
                .poi {
                    position: absolute;
                }

                .poi.inactive {
                    opacity: .3;
                    animation: none;
                }

                .poi.inactive img {
                    animation-play-state: paused;
                }

                .poi.active img {
                    // animation-play-state: paused;
                }

                .label {
                    position: absolute;
                    left: 50%;
                    transform: translateX(-50%);
                }

            `}</style>
        </div>
    )
})

export default MapPOILayer